function getIn(messages, path) {
  if (!messages) return undefined;
  var msg = messages;

  for (var i = 0; i < path.length; ++i) {
    msg = msg[path[i]];
    if (msg === undefined) return undefined;
  }

  return msg;
}

function getPath(id, pathSep) {
  if (!id) return [];
  if (Array.isArray(id)) return id;
  return pathSep ? id.split(pathSep) : [id];
}

export function getMessage(_ref, id, locale) {
  var locales = _ref.locales,
      messages = _ref.messages,
      pathSep = _ref.pathSep;
  if (locale != null) locales = Array.isArray(locale) ? locale : [locale];
  var path = getPath(id, pathSep);

  for (var i = 0; i < locales.length; ++i) {
    var lc = locales[i];
    var msg = getIn(messages[lc], path);
    if (msg !== undefined) return msg;
  }

  return undefined;
}
export function getMessageGetter(context, rootId, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      baseParams = _ref2.baseParams,
      locale = _ref2.locale;

  var pathSep = context.pathSep;
  var pathPrefix = getPath(rootId, pathSep);
  return function message(id, params) {
    var path = pathPrefix.concat(getPath(id, pathSep));
    var msg = getMessage(context, path, locale);
    if (typeof msg !== 'function') return msg;
    var msgParams = baseParams ? Object.assign({}, baseParams, params) : params;
    return msg(msgParams);
  };
}